export default __webpack_public_path__ + "static/media/web.0f904286.png";